import { useCallback } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  setGlobalInvoicesFilters,
  setGlobalInvoicesUnitPrices,
  setGlobalInvoicesQuantity,
  getGlobalInvoicesCRELicenses,
  getGlobalInvoicesPaymentTypes,
} from "redux/actions/globalInvoices/globalInvoicesAction";
import { useValidateReload } from "hooks/useValidateReload";
import { useRevalidateFetch } from "hooks/useRevalidateFetch";

export const useTableGlobalInvoicesConfig = () => {
  const dispatch = useDispatch();

  const handleInputs = useCallback((key = "", value = null) => {
    dispatch(setGlobalInvoicesFilters(key, value));
  }, []);

  const handlePaymentUnitPrice = useCallback(
    (creLicense, taxRate, paymentKey, unitPrice) => {
      dispatch(
        setGlobalInvoicesUnitPrices(creLicense, taxRate, paymentKey, unitPrice),
      );
    },
    [],
  );

  const handlePaymentQuantity = useCallback(
    (creLicense, taxRate, paymentKey, quantity) => {
      dispatch(
        setGlobalInvoicesQuantity(creLicense, taxRate, paymentKey, quantity),
      );
    },
    [],
  );

  return {
    handleInputs,
    handlePaymentUnitPrice,
    handlePaymentQuantity,
  };
};

export const useGlobalInvoicesInit = () => {
  const creLicenses = useSelector(
    (state) => state.globalInvoices.creLicenses,
    shallowEqual,
  );
  const paymentTypes = useSelector(
    (state) => state.globalInvoices.paymentTypes,
    shallowEqual,
  );

  useValidateReload(["loadingGlobalInvoices"]);
  useRevalidateFetch(getGlobalInvoicesCRELicenses, creLicenses);
  useRevalidateFetch(getGlobalInvoicesPaymentTypes, paymentTypes);
};
